module.exports = __webpack_public_path__ + "img/205.6abcbe16.png";